import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { HelpComponent } from '../help/help.component';

@Component({
  selector: 'app-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss']
})
export class MobileComponent implements OnInit {

  settings = false;
  selectedTabIndex = 0;

  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  openDialog() {
    this.dialog.open(HelpComponent, {});
  }

}



// WEBPACK FOOTER //
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/mobile/mobile.component.ts